import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import sk from "./locales/sk.json";
import de from "./locales/de.json";
import sr from "./locales/sr.json";
import ru from "./locales/ru.json";

const savedLang = localStorage.getItem("kronix-lang") || navigator.language?.split("-")[0] || "en";
const supportedLangs = ["en", "sk", "sr", "de", "ru"];
const initialLang = supportedLangs.includes(savedLang) ? savedLang : "en";

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, sk: { translation: sk }, de: { translation: de }, sr: { translation: sr }, ru: { translation: ru } },
  lng: initialLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export const changeLanguage = (lang) => {
  i18n.changeLanguage(lang);
  localStorage.setItem("kronix-lang", lang);
};

export const LANGUAGES = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "sk", label: "Slovenčina", flag: "🇸🇰" },
  { code: "sr", label: "Srpski", flag: "🇷🇸" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
];

export default i18n;
